"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderRoutes = void 0;
function renderRoutes(routes) {
    routes;
    throw new Error('@reactionable/core does not provide routes rendering function, please install a "@reactionable/router-*" package');
}
exports.renderRoutes = renderRoutes;
//# sourceMappingURL=Route.js.map